
import ProductContract from '../contracts/Product'
import Resource from './Resource';
import axios from "axios";

/**
 * Product types
 * @enum
 */
enum ProductType
{
    canvas = 'canvas',
    print = 'print',
}

/**
 * Product class
 * @class
 **/
class Product extends Resource implements ProductContract
{
    /**
     * Resource identifier
     * @type {String}
     **/
    static handle = 'product_id';

    /**
     * Default attributes
     * @type {Object}
     **/
    static attributes: ProductContract = {
        product_id: undefined,
        category_id: undefined,
        type: undefined,
        title: undefined,
        description: undefined,
        price: undefined,
        weight: undefined,
        width: undefined,
        height: undefined,
        depth: undefined,
    };

    /**
     * Resource attributes
     * @type {Object}
     **/
    attributes: ProductContract;

    /**
     * Current attributes
     **/
    readonly product_id: number;
    category_id: number;
    type: ProductType;
    title: string;
    description: string;
    price: number;
    weight: number;
    width: number;
    height: number;
    depth: number;


    /**
     * Get product dimensions
     * @return {String}
     */
    get dimensions(): string
    {
        if( this.width && this.height && this.depth ) {
            return `${ this.width } x ${ this.height } x ${ this.depth } inches`;
        } else if( this.width && this.height ) {
            return `${ this.width } x ${ this.height } inches`;
        }

        return null;
    }


    /**
     * Get all products
     * @return {Promise<Product[]>}
     */
    static all(): Promise<Product[]>
    {
        return axios.get( '/api/products' )
            .then( response => response.data.map( attributes => new Product( attributes, true ) ) );
    }


    /**
     * Get product by id
     * @param {Number} id
     */
    static fetch( id: number ): Promise<Product>
    {
        return axios.get( `/api/product/${ id }` )
            .then( response => new Product( response.data, true ) );
    }


    /**
     * Delete product
     * @return Promise<Boolean>
     */
    delete()
    {
        return axios.delete( `/api/product/${ this.product_id }` ).then( response => {
            this.sync( response.data );
            this.exists = false;
        });
    }


    /**
     * Save product
     * @return {Promise<>}
     */
    save()
    {
        const action = this.exists ? 'patch' : 'put',
            endpoint = this.exists ? `api/product/${ this.product_id }` : '/api/product';

        this.saving = true;
        return axios[action]( endpoint, this.changes ).then( response => {
            this.sync( response.data );
            this.saving = false;
        });
    }
}

Resource.register( Product );

export default Product;
